import { formatDistance } from 'date-fns';
import { PageSection } from '@gettactic/api';
import { IconFromSet, IconValue } from '@cmp-src/icons';
import { cn } from '@gettactic/helpers';
import pluralize from 'pluralize';

export const SectionCard = ({
  section,
  onClick
}: { section: PageSection; onClick: () => void }) => {
  const formattedDate = section.created_at
    ? formatDistance(new Date(section.created_at), new Date(), {
        addSuffix: true
      })
    : null;

  let imageUrl: string | null = null;
  let icon: IconValue | null = null;

  if (section.image_url) {
    try {
      const parsedImage = JSON.parse(section.image_url);
      if (typeof parsedImage === 'string') {
        imageUrl = parsedImage;
      } else if (typeof parsedImage === 'object') {
        icon = parsedImage;
      }
    } catch (e) {
      imageUrl = section.image_url;
    }
  }

  const isClickable = section.pages && section.pages.length > 0;

  return (
    <div
      key={section.id}
      className={cn(
        'flex h-full flex-col overflow-hidden rounded-lg border border-gray-200 shadow-sm transition-shadow duration-200 hover:shadow-md',
        isClickable ? 'cursor-pointer' : 'cursor-default opacity-75'
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          'relative flex items-center justify-start overflow-hidden bg-gray-100',
          imageUrl ? 'h-24' : 'h-12'
        )}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt={section.name}
            className="h-full w-full bg-neutral-50 object-cover"
          />
        )}
        {icon && (
          <span className="ml-3 rounded-md bg-background-primary p-1">
            {/* TBD: fix color */}
            <IconFromSet icon={icon} size={6} color={'#6b7280'} />
          </span>
        )}
      </div>
      <div className="flex flex-grow flex-col p-4">
        <div className="flex flex-col">
          <h1 className="line-clamp-1 font-bold text-sm">{section.name}</h1>
          <p className="mt-2 line-clamp-2 text-gray-600 text-xs">
            {section.description}
          </p>
          {formattedDate && (
            <p className="mt-3 text-muted-foreground text-xs">
              Created {formattedDate}
            </p>
          )}
        </div>
        <div className="mt-auto pt-3">
          {section.pages && section.pages.length > 0 && (
            <p className="text-muted-foreground/50 text-sm">
              {section.pages.length} {pluralize('page', section.pages.length)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
